import { render, staticRenderFns } from "./Nazionale.vue?vue&type=template&id=57629055&"
import script from "./Nazionale.vue?vue&type=script&lang=ts&"
export * from "./Nazionale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports